import type { IconProps } from '../types/IconProps.ts';
export const ChevronDown: IconProps = {
    name: 'ChevronDown',
    children: [
        `<path d="m6 9 5.65 5.65c.2.2.5.2.7 0L18 9" />`,
    ]
};